import { eventBus, EVENTS } from './commons/EventBus.js';
const CENTER=5;
$(document).on('click','.palinsesto-day', (e)=>{
  const date=new Date();
  let child=e.currentTarget;
  var i = 1;
  while( child.previousElementSibling != null ){
    child=child.previousElementSibling;
    i++;
  }
  if(i!=CENTER){
    date.setDate(date.getDate()-(CENTER-i));
  }
  const classToShow='data-'+date.toISOString().substring(0,10);
  
  $('.isselected-1').removeClass('isselected-1').addClass('isselected-0');
  $(`.${classToShow}`).removeClass('isselected-0').addClass('isselected-1');
  $('.palinsesto-day-selected').removeClass('palinsesto-day-selected');
  $(e.currentTarget).addClass('palinsesto-day-selected');
});
eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
  const template=data.template;
  if(template != "palinsesto"){
    return;
  }
  if(window.mainPlayer.playing()){
    onPlay();
  }
  window.mainPlayer.on('resume', onPlay);

  window.mainPlayer.on('pause', () => {
    const playingClass = 'palinsesto-musica-playing';
    $('.actions-programma .palinsesto-musica-play').removeClass(playingClass);
  });  
});
function onPlay() {
  console.log('onplay');
  
  const playingClass = 'palinsesto-musica-playing';
  $('.actions-programma .palinsesto-musica-play').addClass(playingClass);
}


